import { Modal, Button } from "@mui/material"
import {
  ButtonWrapper,
  ModalCard,
  ModalContent,
  ModalHeader,
  Spacer,
} from "./UnassignModal.styles"
import { useInvoiceUnassign } from "../../hooks"
import { useAppDispatch } from "../../app/hooks"
import { openInvoices } from "../../activeScreenSlice"

export interface Props {
  open: boolean
  onClose: () => void
  invoiceIds: number[]
}

export default function UnassignModal(props: Props) {
  const mutation = useInvoiceUnassign()
  const dispatch = useAppDispatch()

  function handleSubmit() {
    mutation.mutate(props.invoiceIds, {
      onSuccess: () => {
        dispatch(openInvoices())
        props.onClose()
      },
      onError: (err) => console.log(err),
    })
  }

  return (
    <Modal open={props.open} onClose={props.onClose}>
      <ModalCard>
        <ModalHeader>You are about to unassign invoices</ModalHeader>
        <ModalContent>
          Please confirm if you want to proceed.
          <br />
          This action will be recorded in each invoice history
        </ModalContent>
        <ButtonWrapper sx={{padding: '8px 0'}}>
          <Spacer />

          <Button
            variant="outlined"
            onClick={props.onClose}
          >
              Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
          >
              Unassign
          </Button>
        </ButtonWrapper>
      </ModalCard>
    </Modal>
  )
}
